export default __webpack_public_path__ + "c3af6b82f834d49e378c45a8f27e6b3f.svg";